import { FC } from "react";
import { Button } from "@gisce/oficina-virtual-components";
import { GetApp } from '@mui/icons-material';
import { IElecContract } from "../Contracts/types/contracts";
import { useVirtualBatteries } from "./hooks/useVirtualBatteries";
import { useTranslation } from "react-i18next";

interface IVirtualBatteryDownloadProps {
  batteries: NonNullable<IElecContract["bateria_virtual"]>;
}

const VirtualBatteryDownload: FC<IVirtualBatteryDownloadProps> = ({
  batteries
}) => {

  const { t } = useTranslation();
  const { exportVirtualBatteries, exporting } = useVirtualBatteries();

  const handleSubmit = () => {

    let battery_ids = ""
    batteries.forEach((bat, idx) => {
      battery_ids += bat.bateria.id
      if (idx < batteries.length - 1) {
        battery_ids += ','
      }
    });

    exportVirtualBatteries(battery_ids);
  }

  return (
    <div style={{marginLeft: "15px"}}>
      <Button 
        variant={'contained'}
        color={'primary'} 
        onClick={handleSubmit}
        loading={exporting}
        startIcon={<GetApp />}
      >
        { t('common:text.solar_wallet.download_excel') } 
      </Button>
    </div>
  );

}

export default VirtualBatteryDownload;